import { useLocation } from 'react-router';
import type { ProductPageLoaderData } from '~/routes/_app.product.$urlSegment';
import getLowestPriceInStockVariant from '../util/get-lowest-price-in-stock-variant';

export const useLandingVariant = (
    product: ProductPageLoaderData['product'],
) => {
    const location = useLocation();

    if (!product.Variants.length) {
        return product.MasterVariant;
    }

    const searchParams = new URLSearchParams(location.search);

    const sku = searchParams.get('sku');
    let landingVariant = product.Variants.find((v) => v.SKU === sku);

    if (landingVariant) {
        return landingVariant;
    }
    const pricingDisplay = product.PricingDisplay;
    if (pricingDisplay && 'ReferenceVariant' in pricingDisplay) {
        landingVariant = product.Variants.find(
            (v) => v.ID === pricingDisplay.ReferenceVariant?.ID,
        );
    }
    if (landingVariant) {
        return landingVariant;
    }

    return getLowestPriceInStockVariant(product.Variants) || null;
};
